module.exports = __webpack_public_path__ + "img/JioMart GS.c5de6b40.svg";